import {
  ParameterSetDto,
  ParameterSetTypeDto
} from 'src/store/parametersets/parameterset';
import { ArrayUtils } from 'src/utils/array';
import { ParameterSetAction, ParameterSetTypes } from './parametersets.actions';

export type ParameterSetsState = Readonly<{
  parameterSets: ParameterSetDto[];
  parameterSetTypes: ParameterSetTypeDto[];
  errors: any;
}>;

const initialState: ParameterSetsState = {
  parameterSets: [],
  parameterSetTypes: [],
  errors: null
};

const parameterSetsReducer = (
  state: ParameterSetsState = initialState,
  action: ParameterSetAction
) => {
  switch (action.type) {
    case ParameterSetTypes.FetchAll:
      return { ...state, parameterSets: action.parameterSets };
    case ParameterSetTypes.Add:
      return {
        ...state,
        parameterSets: [...state.parameterSets, action.parameterSet]
      };
    case ParameterSetTypes.Update:
      return {
        ...state,
        parameterSets: ArrayUtils.updateListById(
          state.parameterSets,
          action.parameterSet
        )
      };
    case ParameterSetTypes.Delete:
      return {
        ...state,
        parameterSet: null,
        parameterSets: ArrayUtils.deleteFromListById(
          state.parameterSets,
          action.parameterSet
        )
      };
    case ParameterSetTypes.Failure:
      return { ...state, errors: action.errors };
    case ParameterSetTypes.FetchTypes:
      return { ...state, parameterSetTypes: action.parameterSetTypes };
    default:
      return state;
  }
};

export default parameterSetsReducer;
